import { render } from "./InviteCourse.vue?vue&type=template&id=6afdec5a&scoped=true"
import script from "./InviteCourse.vue?vue&type=script&lang=js"
export * from "./InviteCourse.vue?vue&type=script&lang=js"

import "./InviteCourse.vue?vue&type=style&index=0&id=6afdec5a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afdec5a"]])

export default __exports__